import { convertLanguageForApi } from '@/utils/langUtils';
import { validateDedaloResultWithSchema } from '@/utils/dedaloUtils';
import { DEDALO_DOMAIN, DEDALO_API_URL, DEDALO_DB_NAME, DEDALO_CODE } from '@/api/dedaloConfig';

export async function fetchDedaloApi(options, schema, lang) {
    const dedalo_get = options.dedalo_get || 'records';
    const url = new URL(DEDALO_API_URL + '/' + dedalo_get);
    const body = {
        code: DEDALO_CODE,
        db_name: DEDALO_DB_NAME,
        lang: options.lang ? options.lang : convertLanguageForApi(lang),
    };

    switch (dedalo_get) {
        case 'records':
            body.dedalo_get = 'records';
            body.table = options.table;
            if (options.ar_fields) body.ar_fields = [...options.ar_fields, 'section_id'];
            if (options.section_id) body.section_id = options.section_id;
            if (options.sql_filter) body.sql_filter = options.sql_filter;
            if (options.order) body.order = options.order;
            if (options.limit) body.limit = options.limit;
            if (options.group) body.group = options.group;
            if (options.offset) body.offset = options.offset;
            if (options.count) body.count = options.count;
            if (options.resolve_portal) body.resolve_portal = options.resolve_portal;
            if (options.resolve_portals_custom)
                body.resolve_portals_custom = options.resolve_portals_custom;
            if (options.resolve_dd_relations)
                body.resolve_dd_relations = options.resolve_dd_relations;
            if (options.process_result) body.process_result = options.process_result;
            break;

        case 'combi':
            body.ar_calls = options.ar_calls.map((call) => {
                call.options.dedalo_get = call.options.dedalo_get || 'records';
                call.options.lang = call.options.lang || convertLanguageForApi(lang);
                return call;
            });
            break;

        case 'reel_terms':
            body.av_section_id = options.av_section_id;
            break;

        case 'fragment_from_index_locator':
            body.index_locator = options.index_locator;
            if (options.fragment_terms) body.fragment_terms = options.fragment_terms;
            break;

        case 'free_search':
            body.q = options.q;
            if (options.rows_per_page) body.rows_per_page = options.rows_per_page;
            if (options.is_literal) body.is_literal = options.is_literal;
            if (options.appearances_limit) body.appearances_limit = options.appearances_limit;
            if (options.video_fragment) body.video_fragment = options.video_fragment;
            break;
    }

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });

    if (!response.ok) {
        throw new Error(`Error fetching data: ${response.status}`);
    }

    const json = await response.json();

    if (import.meta.env.DEV) {
        console.log({
            request: dedalo_get,
            request_options: { ...options, lang: convertLanguageForApi(lang) },
            response: json,
        });
    }

    if (schema) {
        validateDedaloResultWithSchema(json, schema, dedalo_get);
    }

    return json;
}
